import {useQuery} from "@tanstack/react-query"
import {useState} from "react"
import {eventTypeService} from "services"
import {STUDENT_DATA_TEMPLATE_FIELDS} from "types/templates"

const useTemplateFieldsSettings = () => {
    const [templateFields, setTemplateFields] = useState(STUDENT_DATA_TEMPLATE_FIELDS)

    useQuery(
        ["calendar-event-types"],
        async () => {
            const {data} = await eventTypeService.getAll({range: {limit: 100, offset: 0}})
            return data
        },
        {
            initialData: [],
            onSuccess: (data) => {
                const newTemplateFields = [
                    ...STUDENT_DATA_TEMPLATE_FIELDS,
                    {
                        label: "Event Types",
                        options: data.map((option) => ({
                            id: `eventType:${option.eventTypeId}`,
                            name: `${option.name} (${option.code})`
                        }))
                    }
                ]
                setTemplateFields(newTemplateFields)
            }
        }
    )

    return {templateFields}
}

export {useTemplateFieldsSettings}
